import { useRef } from 'react';
import { useState } from 'react';

import useNavigateWithTransition from '@/hooks/useNavigateWithTransition';
import ArtworksOfArtist from '@/pages/profile/artists/artworks-of-artist';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import FollowButton from '@/shared-components/buttons/components/FollowButton';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import ArtistVerifiedIcon from '@/shared-components/icons/components/user-profile/ArtistVerifiedIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/HomeUserCard.css';

export default function HomeUserCard({ userData, style = {}, infiniteScrollObserver }) {
  const navigateWithTransition = useNavigateWithTransition();
  const imageWrapperRef = useRef(null);

  const [openArtworksModal, setOpenArtworksModal] = useState(false);
  const cacheKey = "artworks_of_{0}_in_search";
  const endpoint = "/galleryartist/{0}/artworks";
  const [artistData, setArtistData] = useState({});

  const handleVisitProfile = (e) => {
    e.stopPropagation();
    setArtistData({
      cacheKey: cacheKey.replace("{0}", userData._id),
      endpoint: endpoint.replace("{0}", userData._id),
    });
    setOpenArtworksModal(true);
  };

  return (
    <>
      <div 
        className={`home-user-card-from-search__container element-non-selectable ${userData.user_type === "artist_request" ? "no-cursor" : ""}`}
        style={style} 
        onClick={() => {
          if(userData.user_type === "artist" || userData.user_type === "gallery") {
            imageWrapperRef.current.style.viewTransitionName = `user_${userData._id}_animation`;
            navigateWithTransition(`/user/${userData.user_username}`, { state: { from: true } });
          }
        }} 
        ref={infiniteScrollObserver}
      >
        <div className="home-user-card__image-wrapper" ref={imageWrapperRef}>
          <UserProfileImage 
            className="home-user-card-from-search__image" 
            image={userData.user_image?.image_id} 
            typeOfProfile={userData.user_type}
          />
        </div>
        <div className="home-user-card__info">
          <Text className="home-user-card__user-name-from-search dots-on-overflow" medium>
            {userData.user_name || userData.artist_name}
            {(userData.user_type === "artist" && userData.user_flags.suarteroad_completed) && (
              <ArtistVerifiedIcon className="home-user-card__artist-verified"/>
            )}
          </Text>

          { userData.user_type === "gallery" && (
            <Text className="home-user-card-from-search__username dots-on-overflow" extraSmall>
              {userData.gallery_address.city}, {userData.gallery_address.country}
            </Text>
          )}

          {
            userData.user_type === "artist" &&
                  <Text className="home-user-card-from-search__username dots-on-overflow" extraSmall>
                    {userData.user_addresses.length > 0 && userData.user_addresses[0].address_country}, {userData.user_birth && userData.user_birth.year}
                  </Text>
          } 

          {
            userData.user_type === "artist_request" &&
                  <Text className="home-user-card-from-search__username dots-on-overflow" extraSmall>
                    {userData.artist_nationality}
                  </Text>
          }

          {
                
            (userData.user_type === "artist" || userData.user_type === "gallery") &&
                  (<FollowButton 
                    className="home-user-card-from-search__follow-button" 
                    userId={userData._id} 
                    isFollowingMe={userData.is_following_me} 
                    imFollowing={userData.im_following} 
                    small
                  />)
          }

          {
            userData.user_type === "artist_request" &&
                  <ContinueButton 
                    onClick={(e) => handleVisitProfile(e, userData)} 
                    medium
                    className="continue-button_two"
                  >
                    Visit profile
                  </ContinueButton>
          }
              
        </div>
      </div>

      {openArtworksModal && (
        <ArtworksOfArtist 
          open={openArtworksModal}
          close={() => setOpenArtworksModal(false)}
          artist={userData}
          internal={false}
          showHeader={false}
          cacheKey={artistData.cacheKey}
          queryEndpoint={artistData.endpoint}
        />
      )}
    </>
  );
}
